/* SEETRUE — newsletter takeover: scale the date so it is exactly as wide as
   the form underneath it, whatever the date string or the viewport.

   The CSS already sizes the default date correctly on its own (see
   --nl-date-ratio). This script only needs to correct the size when the date
   text has been changed to something else — so it must never measure before
   the date's own font face has loaded. Measuring during the font-display
   block period returns FALLBACK metrics, and the resulting inline font-size
   overrides the correct CSS value until the refit lands. That is what made
   the date paint at the wrong width and then snap. */
(function () {
  var REFERENCE_SIZE = 100;
  var DATE_FONT = '300 ' + REFERENCE_SIZE + "px 'Poppins Date'";
  var FONT_TIMEOUT = 3000;

  function fit(date) {
    var text = date.querySelector('[data-nl-date-text]');
    if (!text) return;

    var available = date.clientWidth;
    if (!available) return;

    // Measure the string's true advance width at a known size. Any width
    // constraint on the span would clamp this and yield a too-large result,
    // so neutralise them for the measurement.
    date.style.fontSize = REFERENCE_SIZE + 'px';
    var prevMaxWidth = text.style.maxWidth;
    var prevWhiteSpace = text.style.whiteSpace;
    text.style.maxWidth = 'none';
    text.style.whiteSpace = 'nowrap';

    var natural = text.getBoundingClientRect().width;

    text.style.maxWidth = prevMaxWidth;
    text.style.whiteSpace = prevWhiteSpace;

    if (!natural) {
      date.style.fontSize = '';
      return;
    }

    date.style.fontSize = (available / natural) * REFERENCE_SIZE + 'px';
  }

  function fitAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nl-date]').forEach(fit);
  }

  var fontReady = false;

  function whenFontReady() {
    if (!window.Promise) return null;
    if (!document.fonts || !document.fonts.ready) return Promise.resolve();

    var loaded = Promise.resolve()
      .then(function () {
        // Ask for the exact face the date uses, not just any Poppins.
        return document.fonts.load ? document.fonts.load(DATE_FONT, '0123456789.') : null;
      })
      .then(function () {
        return document.fonts.ready;
      })
      .catch(function () {
        // A failed load still needs a fit; fall through.
      });

    // font-display: block gives up at ~3s. Never wait longer than that, so a
    // custom date string still gets fitted if the font never arrives.
    var capped = new Promise(function (resolve) {
      setTimeout(resolve, FONT_TIMEOUT);
    });

    return Promise.race([loaded, capped]);
  }

  function init() {
    var ready = whenFontReady();

    if (!ready) {
      // No Promise support: the CSS ratio is the best we can do.
      fontReady = true;
      fitAll();
      return;
    }

    ready.then(function () {
      fontReady = true;
      fitAll();
    });
  }

  var frame = null;
  function schedule() {
    // Before the font lands, the CSS sizing is already correct — leave it be.
    if (!fontReady) return;
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      frame = null;
      fitAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  // Theme editor: re-measure when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    if (!fontReady) return;
    fitAll(event.target);
  });
})();

/* SEETRUE — newsletter takeover: phone signup.

   Shopify's customer form only accepts a subscriber with an email, so the
   number is turned into a placeholder address (sms-<digits>@<domain>) on
   submit. The number itself is stored in the customer note (a clean column
   in the customer CSV export) and as a tag. Shopify ignores contact[phone]
   on this form, so the Phone column cannot be filled from the theme. */
(function () {
  var PENDING_KEY = 'seetrueNlPending';
  var PENDING_MAX_AGE = 10 * 60 * 1000;
  var MIN_DIGITS = 5;
  var MAX_DIGITS = 15; // E.164 limit, country code included

  function digits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  // Full international number, digits only (no "+").
  function fullNumber(raw, dial) {
    var value = String(raw || '').trim();
    if (value.charAt(0) === '+') return digits(value);
    if (value.indexOf('00') === 0) return digits(value).slice(2);
    // National format: drop the trunk zero(s), prefix the country code.
    return dial + digits(value).replace(/^0+/, '');
  }

  function setup(form) {
    var country = form.querySelector('[data-nl-country]');
    var code = form.querySelector('[data-nl-country-code]');
    var phone = form.querySelector('[data-nl-phone]');
    var email = form.querySelector('[data-nl-email]');
    var tags = form.querySelector('[data-nl-tags]');
    var note = form.querySelector('[data-nl-note]');
    if (!country || !phone || !email) return;

    function syncCode() {
      if (code) code.textContent = '+' + country.value;
    }

    country.addEventListener('change', function () {
      syncCode();
      phone.setCustomValidity('');
      phone.focus();
    });
    syncCode();

    phone.addEventListener('input', function () {
      phone.setCustomValidity('');
    });

    form.addEventListener('submit', function (event) {
      var dial = country.value;
      var number = fullNumber(phone.value, dial);
      var national = digits(phone.value).replace(/^0+/, '');

      if (national.length < MIN_DIGITS || number.length > MAX_DIGITS) {
        event.preventDefault();
        phone.setCustomValidity(phone.getAttribute('data-invalid-message') || 'Invalid phone number');
        phone.reportValidity();
        return;
      }

      email.value = 'sms-' + number + '@' + (email.getAttribute('data-domain') || 'seetrueglasses.com');
      if (tags) tags.value = 'newsletter, sms-signup, phone:+' + number;
      if (note) note.value = '+' + number;
      try {
        sessionStorage.setItem(PENDING_KEY, String(Date.now()));
      } catch (e) {}
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('#NewsletterTakeover').forEach(setup);
  }

  // Coming back from a submit. Shopify either returns straight away with
  // ?customer_posted=true, or first sends the visitor through its bot check
  // (/challenge) — and after that detour Liquid's form.posted_successfully?
  // is not set. So if this visitor just submitted, came back from the check
  // and Shopify rendered no error, show the thank-you note here. Stray form
  // parameters are tidied out of the address bar either way.
  function handleReturn() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var fromChallenge = /\/challenge(\?|\/|$)/.test(document.referrer || '');
    var returned = params.has('customer_posted') || fromChallenge;

    var pending = 0;
    try {
      pending = Number(sessionStorage.getItem(PENDING_KEY)) || 0;
      if (returned || document.querySelector('.nl-page__message--error')) sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}

    if (!returned && !params.has('form_key') && params.get('form_type') !== 'customer') return;

    var success = document.querySelector('[data-nl-success]');
    var failed = document.querySelector('.nl-page__message--error');
    var recent = pending && Date.now() - pending < PENDING_MAX_AGE;
    if (success && success.hidden && !failed && recent && returned) success.hidden = false;
    if (success && !success.hidden) success.focus({ preventScroll: true });

    if (!window.history || !history.replaceState) return;
    ['form_key', 'form_type', 'return_path', 'customer_posted'].forEach(function (key) {
      params.delete(key);
    });
    var query = params.toString();
    history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); handleReturn(); }, { once: true });
  } else {
    init();
    handleReturn();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
